import { Injectable } from "@angular/core";
import "firebase/firestore";
import { ToastrService } from "ngx-toastr";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { Subject } from "rxjs";
import { BehaviorSubject } from "rxjs";
import { PushNotificationsService } from "./push-notification.service";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { Preferences } from "@capacitor/preferences";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  user;
  profile;
  subscription;
  profileSubscription: Subject<any> = new BehaviorSubject<any>({});
  uploadPicture: Subject<boolean> = new BehaviorSubject<any>(false);
  loading: Subject<boolean> = new BehaviorSubject<any>(false);
  loadingQueue = 0;
  constructor(
    private afAuth: AngularFireAuth,
    private afDb: AngularFirestore,
    private pushService: PushNotificationsService,
    private toaster: ToastrService
  ) {
    this.afAuth.onAuthStateChanged(async (user) => {
      this.user = user;
      if (user) {
        const isLogged = await Preferences.get({ key: "logged" });
        if (!isLogged) {
          await Preferences.set({ key: "logged", value: "true" });
        }
        this.afDb
          .collection("profiles")
          .doc(user.uid)
          .valueChanges()
          .subscribe((profile) => {
            this.profileSubscription.next(profile);
            this.profile = profile;
            return this.profile;
          });
      } else {
        if (this.subscription) {
          this.subscription.unsubscribe();
        }
      }
    });
  }

  authObservable = (callback) => {
    this.afAuth.onAuthStateChanged(callback);
  };
  async currentUser() {
    try {
      const isLogged = await Preferences.get({ key: "logged" });
      return isLogged;
    } catch (err) {}
  }
  async waitProfile() {
    return new Promise((resolve) => {
      if (this.profile) return resolve(this.profile);
      const interval = setInterval(() => {
        if (this.profile) {
          clearInterval(interval);
          resolve(this.profile);
        }
      }, 1000);
    });
  }
  uploadingPicture(bool) {
    this.uploadPicture.next(bool);
  }
  isLoading(integer: number) {
    this.loadingQueue += integer;
    if (this.loadingQueue < 0) {
      this.loadingQueue = 0;
    }
    this.loading.next(this.loadingQueue > 0);
  }
  getUserProfile() {
    return this.profile;
  }
  updateProfilePic(photoUrl: any) {
    this.afDb.collection("profiles").doc(this.profile.id).update({ photoUrl });
  }
  async recover(email: string) {
    return await this.afAuth.sendPasswordResetEmail(email);
  }
  checkProfile() {
    return new Promise(async (resolve) => {
      try {
        if (this.user) {
          this.afDb
            .collection("profiles")
            .doc(this.user.uid)
            .valueChanges()
            .subscribe((profile: any) => {
              if (profile && !profile.completed) {
                resolve(false);
              } else {
                resolve(true);
              }
            });
        } else {
          const logged = await Preferences.get({ key: "logged" });
          if (logged) {
            setTimeout(async () => {
              resolve(await this.checkProfile());
            }, 2000);
          } else {
            resolve(true);
          }
        }
      } catch (err) {
        this.toaster.error("Ocurrio un error");
        await this.logout();
      }
    });
  }
  async login(email: string, password: string) {
    try {
      await this.afAuth.signInWithEmailAndPassword(email, password);
      await Preferences.set({ key: "logged", value: "true" });
    } catch (err) {
      throw err;
    }
  }

  async logout() {
    try {
      await this.afAuth.signOut();
      await Preferences.remove({ key: "logged" });
    } catch (err) {
      throw err;
    }
  }
}
